import { supabase } from './supabase';

interface EmailConfig {
  smtp_host: string;
  smtp_port: number;
  smtp_user: string;
  smtp_password: string;
  from_email: string;
  from_name: string;
}

export async function sendEmail(
  to: string,
  subject: string,
  content: string
): Promise<{ error: Error | null }> {
  try {
    // Get email configuration
    const { data: config, error: configError } = await supabase
      .from('email_configuration')
      .select('*')
      .single();

    if (configError) {
      console.error('Failed to get email configuration:', configError);
      throw new Error('Email configuration not found');
    }

    // Call Edge Function to send email
    const { error } = await supabase.functions.invoke('send-email', {
      body: {
        to,
        subject,
        content,
        config
      }
    });

    if (error) {
      console.error('Edge Function error:', error);
      throw error;
    }

    console.log('Email sent successfully to:', to);
    return { error: null };
  } catch (err) {
    console.error('Failed to send email:', err);
    return { error: err instanceof Error ? err : new Error('Failed to send email') };
  }
}